/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_RefreshInputs */

const en_admin_funnel_refresh = /** @type {(inputs: Admin_Funnel_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh`)
};

/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Admin_Funnel_RefreshInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_refresh = /** @type {((inputs?: Admin_Funnel_RefreshInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_RefreshInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_refresh(inputs)
});
export { admin_funnel_refresh as "admin.funnel.refresh" }